import { QuestionNode } from '../../../actionCard/actionCardNodes/question/QuestionNode'

export class LongTextQuestionNode extends QuestionNode {}
